import { getMergedAuthFields } from '@shared/utils';

/**
 * The OAuth 2 sign-in of an app definition and the values the person types before its provider page
 * opens. Some apps build their sign-in address from them (Salesforce's
 * `https://{{credentials.companyDomainName}}.my.salesforce.com/...`, Dynamics 365's
 * `credentials.tenantId`), and the API fills those placeholders from the connection's saved values.
 *
 * The fields are the auth's visible arguments (`getMergedAuthFields`, as the earlier frontend's
 * connection window showed them), without the advanced ones that window folded away. A field is
 * required when the definition says so or when the sign-in address uses it: the catalog does not
 * always mark those (Salesforce's domain is `required: false`), and without it the API cannot build
 * the address. Returns `{ auth: null, fields: [] }` when the definition has no visible OAuth 2 sign-in.
 */
const resolveProviderSignInFields = (definition) => {
  const authentication = Array.isArray(definition?.authentication) ? definition.authentication : [];
  const auth = authentication.find((candidate) => candidate?.type === 'oAuth2' && candidate?.hidden !== true) || null;

  if (!auth) {
    return { auth: null, fields: [] };
  }

  const addressKeys = new Set([...String(auth.authorizeRequest?.url || '').matchAll(/\{\{\s*credentials\.([\w-]+)\s*\}\}/g)].map((match) => match[1]));
  const fields = getMergedAuthFields({ authType: auth.type, auth })
    .filter((field) => field?.isAdvanced !== true)
    .map((field) => ({ ...field, required: field.required === true || addressKeys.has(field.key) }));

  return { auth, fields };
};

export default resolveProviderSignInFields;
